import React from "react";
import {observer} from "mobx-react-lite";
import {Box, Card, CardActionArea, CardContent, Grid, Tooltip, Typography} from "@mui/material";
import Stack from "@mui/material/Stack";
import {useStores} from "../../../stores";
import {generatePath} from "react-router";
import {routes} from "../../../routing/routes.ts";
import type {DashboardCard} from "../DashboardCardConfigs.tsx";
import {CARD_CONFIG} from "../DashboardCardConfigs.tsx";
import {MLink} from "../../_tiny/MLink.tsx";
import {Tag} from "~/components/tag/Tag.tsx";
import {useDashboardsAvailability} from "~/pages/dashboards/services/dashboardsQueries.ts";

type Props = {
    card: DashboardCard
    minSize?: number
}
export const DashboardCardComponent: React.FC<Props> = observer(({card, minSize}) => {
    const {p, bagStore} = useStores();
    const bagId = bagStore.bagId;
    const config = CARD_CONFIG[card];
    const route = config.route;
    const isDisabled = p.isDisabledCard(card, bagStore.bag)
    const disabled = isDisabled.disabled;
    const tooltip: React.ReactNode = isDisabled.message;
    const dashboardsAvailability = useDashboardsAvailability(card === 'dashboards');
    minSize = minSize ?? 3;

    // Superset disabled on the agent (its list endpoints 404): no Dashboards card.
    if (card === 'dashboards' && dashboardsAvailability.isReady && !dashboardsAvailability.isAvailable) {
        return null;
    }

    return <Grid
        className={`dashboard-card${disabled ? ' disabled' : ''}`}
        size={{
            xs: Math.max(12, minSize),
            md: Math.max(6, minSize),
            lg: Math.max(4, minSize),
            xl: Math.max(3, minSize),
        }}>
        <Tooltip title={tooltip}>
            <Card variant="outlined">
                <MLink path={generatePath(routes[route], {id: bagId})} disabled={disabled}>
                    <CardActionArea disabled={disabled}>
                        <CardContent>
                            <Stack
                                component="header"
                                className="card-title"
                                direction="row" justifyContent="space-between" alignItems="center" gap={1}>
                                <Typography variant="h3">
                                    {config.title}

                                </Typography>
                                {p.cardTag(card) === 'trial'
                                  && <Tag label="Trial" variant="filled" color="default" sx={{minHeight: '20px', height: '20px'}}/>
                                }
                                <Box sx={{ml: 'auto'}}>{config.icon}</Box>
                            </Stack>
                            {config.cardDescription &&
                                <Typography component="p" variant="caption">
                                    {isDisabled.message ?? config.cardDescription}
                                </Typography>
                            }
                        </CardContent>
                    </CardActionArea>
                </MLink>
            </Card>
        </Tooltip>
    </Grid>
})
